import { getEvents, getEvent } from '../../../../../api/ApiManager';
import { cloneDeep } from 'lodash';
import camelCaseKeysDeep from 'camelcase-keys-deep';
import { redirectToTemplateManagement } from '../../../common/modules/templateForm';
import { updateNotifications } from '../../../modules/templateChron';
import { hideNotifications } from '../../../../EventDetails/routes/EditOffer/modules/EditOfferModule';

export const FETCH_ALL_EVENTS_SUCCESS = 'FETCH_ALL_EVENTS_SUCCESS';
export const FETCH_ALL_EVENTS_BEGIN = 'FETCH_ALL_EVENTS_BEGIN';
export const FETCH_ALL_EVENTS_FAILURE = 'FETCH_ALL_EVENTS_FAILURE';

export const SEARCH_THRU_EVENTS = 'SEARCH_THRU_EVENTS';
export const FETCH_SPECIFIC_EVENT_DATA_BEGIN =
  'FETCH_SPECIFIC_EVENT_DATA_BEGIN';
export const FETCH_SPECIFIC_EVENT_DATA_SUCCESS =
  'FETCH_SPECIFIC_EVENT_DATA_SUCCESS';
export const FETCH_SPECIFIC_EVENT_DATA = 'FETCH_SPECIFIC_EVENT_DATA';
export const FETCH_SPECIFIC_EVENT_DATA_FAILURE =
  'FETCH_SPECIFIC_EVENT_DATA_FAILURE';
export const CLEAR_EVENT_SEARCH_TEXT = 'CLEAR_EVENT_SEARCH_TEXT';

export const fetchAllEventsSuccess = (allEvents) => {
  return {
    type: FETCH_ALL_EVENTS_SUCCESS,
    allEvents,
  };
};

export const fetchAllEventsBegin = () => {
  return {
    type: FETCH_ALL_EVENTS_BEGIN,
  };
};

export const fetchAllEventsFailure = (err) => {
  return {
    type: FETCH_ALL_EVENTS_FAILURE,
    err,
  };
};

export const searchThruEvents = (searchText) => {
  return {
    type: SEARCH_THRU_EVENTS,
    searchText,
  };
};

export const clearEventSearchText = () => {
  return {
    type: CLEAR_EVENT_SEARCH_TEXT,
  };
};

export const fetchSpecificEventDataBegin = () => {
  return {
    type: FETCH_SPECIFIC_EVENT_DATA_BEGIN,
  };
};

export const fetchSpecificEventDataFailure = (error) => {
  return {
    type: FETCH_SPECIFIC_EVENT_DATA_FAILURE,
    error,
  };
};

export const fetchSpecificEventData = (event) => {
  return (dispatch, getState) => {
    const contextId = getState().app.contextId;
    dispatch(fetchSpecificEventDataBegin());

    return getEvent(contextId, event.id)
      .then((response) => {
        const isSuccess = response.data.hasOwnProperty('Event');

        if (isSuccess) {
          const foundEvent = cloneDeep(response.data.Event);
          const formatEvent = camelCaseKeysDeep(foundEvent);

          dispatch(fetchSpecificEventDataSuccess(formatEvent));
        } else {
          throw new Error(response.data.ResponseStatus.Message);
        }
      })
      .catch((err) => {
        dispatch(fetchSpecificEventDataFailure(err.message));
        dispatch(updateNotifications(`Failed to load event. The server returned: ${err.message}`, 'error', true));
        dispatch(redirectToTemplateManagement());
        
        setTimeout(() => {
          dispatch(hideNotifications());
        }, 8000);
      });
  };
};

export const fetchAllEvents = () => {
  return (dispatch, getState) => {
    dispatch(fetchAllEventsBegin());
    const contextId = getState().app.contextId;
    return getEvents(contextId)
      .then((response) => {
        // const success = response.data.ResponseStatus.Message === 'Success';
        if (response.status === 200) {
          const allEvents = [...response.data.Events];
          const formatEvents = allEvents.map((event) =>
            camelCaseKeysDeep(event)
          );

          dispatch(fetchAllEventsSuccess(formatEvents));
        }
      })
      .catch((err) => {
        dispatch(fetchAllEventsFailure(err));
      });
  };
};

export const fetchSpecificEventDataSuccess = (event) => {
  return {
    type: FETCH_SPECIFIC_EVENT_DATA_SUCCESS,
    event,
  };
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [FETCH_ALL_EVENTS_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, {
      allEvents: action.allEvents,
      importedAllEventsFromBackOffice: true,
      isLoading: false,
      error: '',
    });
    return newState;
  },
  [FETCH_ALL_EVENTS_BEGIN]: (state) => {
    const newState = {};
    Object.assign(
      newState,
      state,
      { isLoading: true },
      { searchResults: [] },
      { searchText: '' }
    );
    return newState;
  },
  [FETCH_ALL_EVENTS_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { error: action.err, isLoading: false });
    return newState;
  },
  [SEARCH_THRU_EVENTS]: (state, action) => {
    const newState = {};

    const newSearchResults = state.allEvents.filter((evt) => {
      const evtName = evt.eventName ? evt.eventName.toLowerCase() : '';
      const lookupId = evt.lookupId ? evt.lookupId.toLowerCase() : '';
      const text = action.searchText.toLowerCase();

      return evtName.indexOf(text) !== -1 || lookupId.indexOf(text) !== -1;
    });
    Object.assign(
      newState,
      state,
      { searchText: action.searchText },
      { searchResults: newSearchResults }
    );
    return newState;
  },
  [CLEAR_EVENT_SEARCH_TEXT]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { searchText: '' });
    return newState;
  },
  [FETCH_SPECIFIC_EVENT_DATA_BEGIN]: (state) => {
    const newState = {};
    Object.assign(newState, state);
    return newState;
  },
  [FETCH_SPECIFIC_EVENT_DATA_SUCCESS]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { event: action.event });
    return newState;
  },
  [FETCH_SPECIFIC_EVENT_DATA_FAILURE]: (state, action) => {
    const newState = {};
    Object.assign(newState, state, { error: action.error });
    return newState;
  },
};

// ------------------------------------
// Initial State
// ------------------------------------

const initialState = {
  isLoading: false,
  importedAllEventsFromBackOffice: false,
  searchResults: [],
  searchText: '',
  linkEventFromBackOfficeSuccess: false,
  allEvents: [],
  event: {},
  error: '',
};

// ------------------------------------
// Reducer
// ------------------------------------

export default function createEventReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/routes/Templates/routes/CreateTemplate/modules/importEvent.js